import { RefreshCw } from 'lucide-react';
import { useVersionCheck } from '@/hooks/useVersionCheck';

/**
 * 새 버전 배포 감지 배너.
 * 감지 즉시 강제 새로고침하는 대신 사용자가 시점을 선택하게 하고,
 * 미조치 시 다음 자정 자동 새로고침까지 남은 시간을 표시한다.
 */
export function UpdateBanner() {
  const { hasNewVersion, reload, countdownLabel } = useVersionCheck();

  if (!hasNewVersion) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] animate-banner-enter">
      <div className="flex items-center justify-center gap-3 bg-blue-600 px-4 py-2.5 text-white shadow-lg dark:bg-blue-500">
        <RefreshCw className="h-4 w-4 shrink-0" />
        <span className="text-sm font-medium">새 버전이 배포되었습니다</span>
        {countdownLabel && (
          <span className="text-xs opacity-90 tabular-nums">{countdownLabel}</span>
        )}
        <button
          type="button"
          onClick={() => void reload()}
          className="ml-1 rounded-md bg-white px-3 py-1 text-sm font-semibold text-blue-600 transition-colors hover:bg-blue-50"
        >
          지금 새로고침
        </button>
      </div>
    </div>
  );
}
